import Vue from 'vue';
import './registerServiceWorker';
import router from './router';

import { VueDiContainer } from 'vue-di-container';
import najizMui from '@moj/najiz-mui';
import najizToaster, { IToasterAPI } from '@moj/najiz-toastify';
// Plugins
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
// Components
import App from './views/App/app';
// styles
import '../public/styles/main.scss';
import AxiosService from './services/axios';
import LoaderService from './services/loader';
import UserService from './services/user';
import initializeApplication from './plugins/application-initialization';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(najizMui);
Vue.use(VueDiContainer);
Vue.use(najizToaster);

declare module 'vue/types/vue' {
  interface Vue {
    $nToaster: IToasterAPI;
  }
}
declare global {
  interface Window {
    $config: any;
    $disableNewRequestsPeriod: any;
    showLoader(): void;
    hideLoader(): void;
  }
}

initializeApplication().then(() => {
  new Vue({
    i18n,
    router,
    vuetify,
    diProvide: [
      AxiosService,
      LoaderService,
      UserService,
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
